import { HttpErrorResponse } from '@angular/common/http';

export class HttpError extends Error {
  constructor(public response: HttpErrorResponse) {
    super(response.message);
  }
}
